import { axiosInstance, requestConfig } from 'network/apis';

import { URL_BILLING } from "utils/constants";

export const callShopRecurringPayment = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/shop-payment/recurring-payment'));
};

export const callShopPaymentMethod = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/payment-method'));
};

export const callShopPaymentMethodAdd = async (paymentMethodType) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, `/payment-method/${paymentMethodType}`));
};

export const callShopPaymentMethodDelete = async (paymentMethodIdx) => {
    return await axiosInstance(requestConfig('delete', URL_BILLING, `/payment-method/${paymentMethodIdx}`));
};

export const callShopRecurringPaymentCancel = async () => {
    return await axiosInstance(requestConfig('post', URL_BILLING, '/recurring-payment/cancel'));
};

export const callRecurringPayment = async (paymentGatewayUrl) => {
    return await axiosInstance(requestConfig('get', URL_BILLING, `${paymentGatewayUrl}`));
};

export const callMyBankAcccountPaymentApprovalRequest = async (paymentApprovalToken) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, `/settlebank/bank-account/payment/approval/${paymentApprovalToken}`));
};

export const callCreditCardPaymentVerifyRequest = async (paymentVerifyToken) => {
    return await axiosInstance(requestConfig('get', URL_BILLING, `/settlebank/credit-card/payment/verify/${paymentVerifyToken}`));
};

